<template>
	<el-aside :width="(isCollapse ? '64px' : '250px')">
        <el-menu
			:default-active="activeindex"
			class="el-menu-custom"
			:collapse="isCollapse"
			background-color="#8b9095"
			text-color="#fff"
			active-text-color="#ffd04b">

			<div class="logo">
				<a href="/home" class="simple-text" >
					<div class="logo-img" >
						<!-- <img src="/static/img/logo.png" alt=""> -->
					</div>
					<span v-if="!isCollapse">GRDAR</span>
				</a>
			</div>
			<el-menu-item index="users" @click="cambio('/admin/users')">
				<i class="el-icon-menu"></i>
				<span slot="title">Usuarios</span>
			</el-menu-item>
			<el-menu-item index="projects" @click="cambio('/admin/projects')">
				<i class="el-icon-menu"></i>
				<span slot="title">Proyectos</span>
			</el-menu-item>
			<el-menu-item index="levels" @click="cambio('/admin/levels')">
				<i class="el-icon-menu"></i>
				<span slot="title">Niveles</span>
			</el-menu-item>
      	</el-menu>
    </el-aside>
</template>
<script>
import { mapGetters } from "vuex";
import { FECTH_SIDEBAR, FECTH_NAME_SIDEBAR } from "@/store/actions.type";

export default {
	name: "sidebar",
	computed: {
		...mapGetters(["isAdmin", "currentUser"])
	},
	created() {
		window.localStorage.getItem("isCollapse") == "true"
			? (this.isCollapse = true)
			: (this.isCollapse = false);
		this.$root.$on("toogleChange", () => {
			this.toggle();
		});
	},
	beforeDestroy() {
    this.$root.$off("toogleChange", () => {
			this.toggle();
		});
  },
	data() {
		return {
			links: null,
			table: null,
			isCollapse: false,
			activeindex: null,
			show: false
		};
	},
	methods: {
		cambio(href, name) {
			this.$router.push(href);
		},
		toggle() {
			this.isCollapse = !this.isCollapse;
			window.localStorage.setItem("isCollapse", this.isCollapse);
		}
	}
}
</script>


<style lang="scss" scoped>
	.el-aside,
	.el-menu {
		min-height: calc(100vh);
	}
	.el-menu-custom {
		border-right: none;
	}
	.logo {
		height: 60px;
		display: flex;
		align-items: center;
		justify-content: space-around;
		position: relative;
		&:before {
			content: "";
			position: absolute;
			bottom: 0;
			left: 50%;
			transform: translate(-50%, 0);
			height: 1px;
			width: 90%;
			background: white;
		}
		> .simple-text {
			color: white;
			font-weight: 700;
			> .logo-img {
				max-height: 55px;
				max-width: 55px;
				display: inline-block;
				> img {
					max-width: 100%;
					padding-right: 10px;
				}
			}
		}
		.close {
			width: 64px;
		}
	}

	.el-menu-custom i {
		color: #fff !important;
	}
</style>



// WEBPACK FOOTER //
// src/components/CloudAdmin/Sidebar.vue